import { FormInstance, message } from "antd";
import { updateInvoiceStatus } from "../../services/milestoneTrackerApi";

export { useTrackerData, useTrackerFilters } from "../useMilestoneInvoice";


export const useInvoiceSave=({form,editRow,onClose,reloadTrackerData })=>{
     const handleSave = async () => {
    try {
      await form.validateFields();

      if (editRow) {
        const invoiceStatus = form.getFieldValue("invoiceStatus");
        const pendingReason = form.getFieldValue("pendingReason");
        const payload = {
          projectId: editRow.projectId,
          invoiceId: editRow.id,
          invoicingStatus: invoiceStatus,
          reason:
            invoiceStatus === "Invoiced"
              ? ""
              : String(pendingReason || "").trim(),
        };

        await updateInvoiceStatus(payload);

        message.success("Invoice status updated successfully!");
        await reloadTrackerData();
      } else {
        message.success("Milestone added!");
      }

      onClose();
      form.resetFields();
    } catch (error) {
      if (error instanceof Error) {
        message.error(error.message);
      }
    }
  };
   return { handleSave };
}

// interface UseInvoiceUploadProps {}
// export const useInvoiceUpload=({}: UseInvoiceUploadProps)=>{
    

// }